import React, { useEffect, useState } from "react";
import axios from "axios";
import { Container, Row, Col, Spinner } from "react-bootstrap";
import { Link, useHistory } from "react-router-dom";

// ⭐ Star Rating Component
const StarRating = ({ rating }) => {
    const stars = [];
    for (let i = 1; i <= 5; i++) {
        stars.push(
            <span key={i} className={`me-1 ${i <= rating ? "text-warning" : "text-muted"}`}>
                ★
            </span>
        );
    }

    return (
        <div className="d-flex align-items-center">
            {stars}
            <span className="ms-2 fw-semibold">{parseFloat(rating).toFixed(1)}</span>
        </div>
    );
};

const Courses = () => {
    const [courses, setCourses] = useState([]);
    const [loading, setLoading] = useState(true);
    const history = useHistory();
    const userId = localStorage.getItem("customer_id");

    useEffect(() => {
        const fetchCourses = async () => {
            if (!userId) {
                console.error("User ID not found in localStorage.");
                setLoading(false);
                return;
            }

            try {
                const response = await axios.get(
                    `${process.env.REACT_APP_API_BASE_URL}/user/${userId}/courses`
                );
                const courseData = response.data.data;
                setCourses(courseData);

                // ✅ Store purchased course slugs
                const slugs = courseData.map((course) => course.slug);
                localStorage.setItem("purchased_courses", JSON.stringify(slugs));
            } catch (error) {
                console.error("Error fetching courses:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchCourses();
    }, [userId]);

    const getImageUrl = (imagePath) => {
        return `${process.env.REACT_APP_ASSET_BASE_URL}/storage/${imagePath}`;
    };

    return (
        <Container className="my-5">
            <h2 className="mb-4 text-center">My Courses</h2>

            {loading ? (
                <div className="text-center">
                    <Spinner animation="border" variant="primary" />
                </div>
            ) : courses.length === 0 ? (
                <p className="text-muted text-center">No courses found.</p>
            ) : (
                <Row>
                    {courses.map((course) => (
                        <Col md={6} lg={4} key={course.id} className="mb-4">
                            <div className="rn-card h-100 d-flex flex-column shadow-sm">
                                <div className="inner d-flex flex-column h-100">
                                    {/* Thumbnail */}
                                    <div className="thumbnail position-relative">
                                        <Link to={`/course-details/${course.slug}`}>
                                            <img
                                                src={getImageUrl(course.image)}
                                                alt={course.title}
                                                className="img-fluid w-100"
                                                style={{ height: "200px", objectFit: "cover" }}
                                                onError={(e) => {
                                                    e.target.onerror = null;
                                                    e.target.src =
                                                        "https://via.placeholder.com/400x200?text=No+Image";
                                                }}
                                            />
                                        </Link>
                                    </div>

                                    {/* Title */}
                                    <h4 className="text-center my-3 flex-grow-0 px-3">
                                        <Link to={`/course-details/${course.slug}`}>
                                            {course.title}
                                        </Link>
                                    </h4>

                                    {/* Rating & Price */}
                                    <div className="d-flex justify-content-between align-items-center px-4 mb-3 flex-grow-0">
                                        <StarRating rating={parseFloat(course.rating) || 4.5} />
                                        <span className="text-success fw-bold">
                                            ৳{parseFloat(course.price).toFixed(2)}
                                        </span>
                                    </div>

                                    {/* Spacer */}
                                    <div className="flex-grow-1"></div>

                                    {/* Start Button */}
                                    <div className="text-center px-4 pb-4">
                                        <Link
                                            to={`/course-playlist/${course.slug}`}
                                            className="btn-default w-100"
                                        >
                                            Start Course
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    ))}
                </Row>
            )}
        </Container>
    );
};

export default Courses;
